import { BsCart } from "react-icons/bs";
import { MdOutlineVerifiedUser } from "react-icons/md";

export const firstNavData = [
  {
    logo: <BsCart className="text-lg" />,
    text: "Buy now, pay later with afterpay",
  },
  {
    logo: <MdOutlineVerifiedUser className="text-lg" />,
    text: "30-day warranty and easy returns",
  },
];
